import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api } from '../../app/api'

function normalizeArrayPayload(payload) {
  if (Array.isArray(payload)) return payload
  if (payload == null) return []
  if (Array.isArray(payload.data)) return payload.data
  if (Array.isArray(payload.themes)) return payload.themes
  if (Array.isArray(payload.employees)) return payload.employees
  if (Array.isArray(payload.items)) return payload.items
  return []
}

export const fetchTickets = createAsyncThunk(
  'tickets/fetchTickets',
  async ({ token }) => {
    api.defaults.headers = {
      Authorization: `Bearer ${token}`
    }
    const response = await api.get('/tickets')
    return response.data
  }
)
export const createTicket = createAsyncThunk(
  'tickets/createTicket',
  async ({ token, message, name }) => {
    api.defaults.headers = {
      Authorization: `Bearer ${token}`
    }
    const response = await api.post('/ticket', { theme:'1', message, name})
    return response.data
  }
)
export const fetchTicketTheme = createAsyncThunk(
  'tickets/fetchTicketTheme',
  async ({token}) => {
    api.defaults.headers = {
      Authorization: `Bearer ${token}`
    }
    const response = await api.get('/themes')
    return response.data
  }
)
export const fetchTicket = createAsyncThunk(
  'tickets/fetchTicket',
  async ({token, id}) => {
    api.defaults.headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    const response = await api.get(`ticket/${id}`)
    return response.data
  }
)

export const fetchTicketHelpers = createAsyncThunk(
    'tickets/fetchTicketHelpers',
    async () => {
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
        const response = await api.get('administration/employees')
        return response.data
    }
)
export const sendSms = createAsyncThunk(
  'tickets/sendSms',
  async ({token, id, message}) => {
    api.defaults.headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    const response = await api.post(`message/${id}`, { message })
    return response.data
  }
)

export const addRating = createAsyncThunk(
    'user/addRating',
    async ({id, rating}) => {
        const response = await api.patch(`/ticket/${id}/rate `, {rating: rating})
        return response.data
    }
)

const ticketSlice = createSlice({
  name: 'tickets',
  initialState: {
    isLoaded: false,
    tickets: [],
    helpersLoading: false,
    ticketHelpers: [],
    ticket: {},
    themes: [],
    error: {
      failed: false,
      message: null,
    },
  },
  extraReducers: {
    [fetchTickets.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [fetchTickets.fulfilled]: (state, action) => {
      state.tickets = action.payload
      state.isLoaded = true;
    },
    [fetchTickets.rejected]: (state, action) => {
      state.isLoaded = false;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [createTicket.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [createTicket.fulfilled]: (state) => {
      state.isLoaded = true;
    },
    [createTicket.rejected]: (state, action) => {
      state.isLoaded = false;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [fetchTicketTheme.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [fetchTicketTheme.fulfilled]: (state, action) => {
      state.themes = normalizeArrayPayload(action.payload)
      state.isLoaded = true;
    },
    [fetchTicketTheme.rejected]: (state, action) => {
      state.isLoaded = false;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [fetchTicket.pending]: (state) => {
      state.isLoaded = false;
      state.error.failed = false;
      state.error.message = null;
    },
    [fetchTicket.fulfilled]: (state, action) => {
      state.ticket = action.payload
      state.isLoaded = true;
    },
    [fetchTicket.rejected]: (state, action) => {
      state.isLoaded = false;
      state.error.message = action.payload;
      state.error.failed = true;
    },
    [addRating.fulfilled]: (state, action) => {
        state.ticket = action.payload
    },
      [fetchTicketHelpers.pending]: (state) => {
          state.helpersLoading = true;
          state.error.failed = false;
          state.error.message = null;
      },
      [fetchTicketHelpers.fulfilled]: (state, action) => {
          state.ticketHelpers = normalizeArrayPayload(action.payload)
          state.helpersLoading = false;
      },
      [fetchTicketHelpers.rejected]: (state, action) => {
          state.helpersLoading = false;
          state.error.message = action.payload;
          state.error.failed = true;
      },
  }
})

export default ticketSlice.reducer
